<template>
  <div class="content">
    <!-- 预警信息  -->
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>预警信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style="display:flex;justify-content: space-between;align-items: center;height:60px;padding:0 1vw;" >
            <div class="grid-search">
              <!-- <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker>
              <el-input v-model="search.personName" style="width:200px" placeholder="请输入人员姓名" clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input> -->
            </div>
            <div style="display:flex;margin:0px 0px 0px 0px;justify-content: space-between;align-items:center">
              <el-button type="primary" @click="addPlan">创建信息</el-button>
            </div>
          </div>
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :default-sort="{prop: 'clockTime', order: 'descending'}"
              :header-cell-style="{background:'#EBEBEB',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="标题">
                <template slot-scope="scope">
                  <span>{{ scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.napeName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="内容">
                <template slot-scope="scope">
                  <span>{{ scope.row.around }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="检查记录" width="200">
                <template slot-scope="scope">
                  <el-button type="success" plain size="mini" @click="sumbitInfo(scope.row)" style="margin-top:0.5vh;margin-bottom:0.5vh;">查看</el-button>
                </template>
              </el-table-column> -->
              
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
            <!-- 人员修改 -->
            <el-dialog width="500px" title="创建预警信息" :visible.sync="modifyVisible" append-to-body>
              <el-form
                :model="workerInfo"
                ref="workerInfo"
                label-width="160px"
                label-position="right"
                :rules="rules"
              >
                <el-form-item label="标题：">
                  <el-input v-model="workerInfo.name" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="预警类型：">
                  <el-select v-model="workerInfo.type" placeholder="请选择">
                    <el-option label="环境预警" value="1"></el-option>
                    <el-option label="事故预警" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="具体内容：">
                  <el-input v-model="workerInfo.contain" type="textarea" :rows="2" autocomplete="off" style="width:220px;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo('workerInfo')">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [],
      search: {
        //查询
        // name: '',
        // projectId: '',
        // date:util.myTime.getCurTime(),
        // temperatureType:'2',
        // teamsId: '',
        // entId: '',
        // personName: '',
      },
      groupId: '',
      dataText: '数据加载中...',
      
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      modifyVisible: false,
      workerInfo: {
        id: '',
        name:'',
        type:'1',
        contain:''
      },
      rules:{
        name:[
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        napeId:[
          { required: true, message: '请输入计划检查事项', trigger: 'change' },
        ],
        around:[
          { required: true, message: '请输入检查范围', trigger: 'blur' },
        ],
        entId:[
          { required: true, message: '请输入检查责任单位', trigger: 'change' },
        ],
        userId:[
          { required: true, message: '请输入检查责任人', trigger: 'change' },
        ],
        planDate:[
          { required: true, message: '请输入检查时间', trigger: 'blur' },
        ],
      },
      //检查事项列表
      napeList:[],
      //责任单位
      entList:[],
      //责任人
      personList:[],
    }
  },
  created() {
    this.groupId = util.session.get('groupId')
  },
  mounted() {
    this.search.projectId = this.groupId
    if (this.search.projectId == '') {
      this.$store.commit('setGroupId')
      this.search.projectId = this.$store.state.groupId
    }
    this.getNapeList()
    this.getEntList()
    this.getPerosn()
    this.getData()
  },
  methods: {
    //获取事项
    getNapeList(){
      var that = this
      myHttp.selectProQsNapeListByProjectId({
        projectId:this.groupId
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var list = resp.data.data.proQsNapes||[]
          that.napeList = list
        }
      })
    },
    //责任单位
    getEntList(){
      var that = this
      myHttp.getProjectEntByProjectId({
          projectId:this.groupId
      }).then(function(resp){
          if (resp.data.code == '200'){
              var list = resp.data.data.projectEnt || []
              that.entList = list
          }
      })
    },
    //获取人员
    getPerosn(){
      var that = this
      myHttp.getRoleUserList({
        userType:util.session.get('roleId'),
        groupId:this.groupId
      }).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.users||[];
            that.personList = list;
        }
      },function(){});
    },
    //
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
    // 搜索数据
    doFilter(index) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.listData = []
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.selectProQsPlanPage(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for(var i=0;i<list.length;i++){
              list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
            }
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }else{
              that.totalItems = resp.data.data.pageInfo.total||0
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    
    //添加计划
    addPlan(){
      this.modifyVisible = true
      this.workerInfo.napeId = ''
      this.workerInfo.around = ''
      this.workerInfo.entId = ''
      this.workerInfo.planDate = ''
      this.workerInfo.userId = ''
    },
    
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
    /**
     * 提交
     */
    modifyWorkerInfo(formName){
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.workerInfo.projectId = this.groupId
          myHttp.createProQsPlan(that.workerInfo).then(function(resp){
            console.log(resp)
            if(resp.data.code=='200'){
              that.$message.success('提交成功')
              that.modifyVisible = false
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    /**
     * 查看
     */
    sumbitInfo(row){
      this.$router.push({path:'/planProHis/'+row.id})
    },

  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
</style>
<style scoped>
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }
  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }
  .content >>> .el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }
  .build-table {
    height: calc(100% - 100px);
    padding: 1vh;
    position: relative;
  }
  .cur{
    background: #ECF5FF !important;
    color:#409EFF !important  ;
  }
  div >>> .el-dialog__header {
    padding: 20px 20px 10px;
    text-align: center !important;
  }
  .send >>> .el-dialog__header {
    text-align: left !important;
  }
  div >>> .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: center;
    box-sizing: border-box;
  }
  div >>>.el-input-group--append .el-input__inner{
    width: 200px;
  }
  .dialog_send{
    margin:10px 0px 10px 35px;
  }
  .dialog_end{
    padding:30px 0px 10px 35px;
    display: flex;
    justify-content: flex-end;
  }
  .else{
    justify-content: space-between;
    border-top: 1px dotted #ECF5FF;
  }
  .tips{
        display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
  }
</style>